import React, { Component } from "react";

import withProducts from "containers/withProducts";
import withTranslations from "containers/withTranslations";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { compose } from "react-apollo";
import getRelativeUrl from "utils/getRelativeUrl";
import styled from "styled-components";
import theme from "ui/styles/theme";
import easing from "ui/styles/easing";
import { Container, Row, Col, media } from "styled-bootstrap-grid";
import Loading from "../../generic/Loading";

import Product from "./Product";
import IconCapacitive from "./IconCapacitive";
import IconClimate from "./IconClimate";
import IconManagement from "./IconManagement";
import IconMonitoring from "./IconMonitoringSolutions";

const StyledContainer = styled(Container)`
  padding-left: 0 !important;
  padding-right: 0 !important;

  ${media.sm`
    padding-left: ${theme.grid.container.padding}px !important;
    padding-right: ${theme.grid.container.padding}px !important;
  `}
`;

const FilterWrapper = styled.div`
  background: ${theme.colors.primary};
`;

const FilterTextContainer = styled.div`
  margin: 32px 20px 0;

  ${media.sm`
    margin: 32px 32px 0;
  `}
`;

const FilterText = styled.p`
  border-top: 1px solid white;
  display: block;
  color: white;
  text-transform: uppercase;
  padding-top: 32px;
  margin: 0;
`;

const FilterContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  // padding: 50px 20px;
  padding: 50px 0px;

  ${media.sm`
  justify-content: space-around;
  `}
`;

const Filter = styled.button`
  background-color: ${(props) =>
    props.active ? "white" : theme.colors.accents.primary};
  color: ${(props) =>
    props.active ? theme.colors.primary : theme.colors.secondary};
  flex-grow: 0;
  border: none;
  padding: 20px 10px 28px;
  display: flex;
  transition: color 0.3s ${easing.easeOutCubic},
    background-color 0.3s ${easing.easeOutCubic};
  outline: none;
  width: 100%;
  flex-wrap: wrap;
  text-align: center;
  overflow: hidden;
  justify-content: center;
  font-size: 10px;
  flex-direction: column;
  align-content: center;
  height: 100%;
  align-items: center;

  p {
    margin: 0;
  }

  ${media.sm`
    font-size: 20px;
    padding: 20px 28px 28px;
    //margin: 0 18px;
    margin: 0;
    width: 100%;
    // flex-grow: 1;
  `}

  &:hover {
    background-color: white;
    color: ${theme.colors.primary};
  }
`;
const CategoryLink = styled(Link)`
  text-decoration: none;
  width: 40%;

  ${media.sm`
width: 100%;
`}
`;

const Icon = styled.div`
  margin-bottom: 20px;

  ${media.sm`
    margin-right: 0px;
    margin-bottom: 0;
  `}
`;

const ButtonName = styled.p`
  align-self: center;
`;

const ProductWrapper = styled.div`
  padding: 80px 0;
`;

const RowExtended = styled(Row)`
  justify-content: ${(props) =>
    props.management ? "center" : "space-between"};
  margin: 0px;
  width: 100%;
`;

class Products extends Component {
  constructor(props) {
    super(props);

    this.setHover = this.setHover.bind(this);
    this.setFilter = this.setFilter.bind(this);
  }

  state = {
    hover: null,
    filter: null,
    finishedSorting: false,
    isDataReady: false,
  };

  componentDidMount() {
    if (this.props.products && this.props.products.length > 0) {
      this.initializeComponent();
    }
  }

  componentDidUpdate(prevProps) {
    // Check if products just became available
    if (
      !prevProps.products.length &&
      this.props.products.length &&
      !this.state.isDataReady
    ) {
      this.initializeComponent();
    }
  }

  initializeComponent() {
    const { urlManagement, urlClimate, urlCapacitive } = this.props;

    // Set initial filter based on URL
    let initialFilter = null;
    if (window.location.href.toString().includes(urlManagement)) {
      initialFilter = "management";
    } else if (window.location.href.toString().includes(urlClimate)) {
      initialFilter = "climate";
    } else if (window.location.href.toString().includes(urlCapacitive)) {
      initialFilter = "capacitive";
    }

    this.setState({
      filter: initialFilter,
      isDataReady: true,
    });
  }

  setHover(filter) {
    this.setState({ hover: filter });
  }

  setFilter(filter) {
    if (filter === this.state.filter) {
      this.setState({ filter: null });
    } else {
      this.setState({ filter });
    }
  }

  getProducts() {
    if (!this.props.products || !this.state.isDataReady) {
      return [];
    }
    const filter = this.state.filter;
    const filteredList = this.props.products.filter((product) =>
      filter ? product.type === filter : true
    );

    return [...filteredList].sort((a, b) => a.menuOrder - b.menuOrder);
  }

  render() {
    const products = this.getProducts();
    const {
      text,
      translations,
      urlManagement,
      urlClimate,
      urlCapacitive,
      hide_management,
    } = this.props;

    return (
      <StyledContainer fluid>
        <FilterWrapper>
          <RowExtended>
            <Col sm={10} smOffset={1}>
              {text && (
                <FilterTextContainer>
                  <FilterText>{text}</FilterText>
                </FilterTextContainer>
              )}

              <FilterContainer>
                <RowExtended management={hide_management}>
                  {urlCapacitive && (
                    <Col sm={4} xs={4}>
                      <CategoryLink to={getRelativeUrl(urlCapacitive)}>
                        <Filter
                          onMouseEnter={(e) => this.setHover("capacitive")}
                          onMouseLeave={(e) => this.setHover(null)}
                          active={this.state.filter === "capacitive"}
                        >
                          <Icon>
                            <IconCapacitive
                              active={this.state.filter === "capacitive"}
                              hover={this.state.hover === "capacitive"}
                            />
                          </Icon>
                          <ButtonName>
                            {translations &&
                              translations.productTypes.capacitive}
                          </ButtonName>
                        </Filter>
                      </CategoryLink>
                    </Col>
                  )}
                  {urlClimate && (
                    <Col sm={4} xs={4}>
                      <CategoryLink to={getRelativeUrl(urlClimate)}>
                        <Filter
                          onMouseEnter={(e) => this.setHover("climate")}
                          onMouseLeave={(e) => this.setHover(null)}
                          active={this.state.filter === "climate"}
                        >
                          <Icon>
                            <IconClimate
                              active={this.state.filter === "climate"}
                              hover={this.state.hover === "climate"}
                            />
                          </Icon>
                          <ButtonName>
                            {translations && translations.productTypes.climate}
                          </ButtonName>
                        </Filter>
                      </CategoryLink>
                    </Col>
                  )}
                  {urlManagement && !hide_management && (
                    <Col sm={4} xs={4}>
                      <CategoryLink to={getRelativeUrl(urlManagement)}>
                        <Filter
                          onMouseEnter={(e) => this.setHover("management")}
                          onMouseLeave={(e) => this.setHover(null)}
                          active={this.state.filter === "management"}
                        >
                          <Icon>
                            <IconMonitoring
                              active={this.state.filter === "management"}
                              hover={this.state.hover === "management"}
                            />
                          </Icon>
                          <ButtonName>
                            {translations &&
                              translations.productTypes.management}
                          </ButtonName>
                        </Filter>
                      </CategoryLink>
                    </Col>
                  )}
                </RowExtended>
              </FilterContainer>
            </Col>
          </RowExtended>
        </FilterWrapper>
        <ProductWrapper>
          <RowExtended>
            <Col sm={10} smOffset={1}>
              <RowExtended>
                {this.state.isDataReady &&
                  products.map((product) => {
                    return (
                      <Col sm={6} key={`${product.id}-${product.title}`}>
                        {console.log(product)}
                        <Product
                          video={product.video ? product.video.sourceUrl : null}
                          image={product.image ? product.image.sourceUrl : null}
                          title={product.title}
                          link={product.link}
                        />
                      </Col>
                    );
                  })}
                {!this.state.isDataReady && <Loading></Loading>}
              </RowExtended>
            </Col>
          </RowExtended>
        </ProductWrapper>
      </StyledContainer>
    );
  }
}

export default compose(
  withRouter,
  withTranslations(),
  withProducts()
)(Products);



// WEBPACK FOOTER //
// ./src/ui/components/modules/ProductsNew/index.js